import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";
import AES from "crypto-js/aes";
import pad from "crypto-js/pad-pkcs7";
import { inflate } from "pako";
import { store } from "../store";

function convertWordArrayToUint8Array(wordArray) {
    const len = wordArray.words.length;
    const u8_array = new Uint8Array(len << 2);
    let offset = 0;
    let word;
    let i;

    for (i = 0; i < len; i++) {
        word = wordArray.words[i];
        u8_array[offset++] = word >> 24;
        u8_array[offset++] = (word >> 16) & 0xff;
        u8_array[offset++] = (word >> 8) & 0xff;
        u8_array[offset++] = word & 0xff;
    }

    return u8_array;
}

function decodeKey(encrypted_key) {
    let decodeKey = "";

    for (let i = 0; i < encrypted_key.length; ++i) {
        decodeKey += String.fromCharCode(encrypted_key.charCodeAt(i) - 2);
    }

    return decodeKey;
}

export function decrypt(data) {
    if (typeof data !== "string") {
        return data;
    }

    const iv = Utf8.parse("RKz5xwoVgaXqfrh9");
    const base64Decoded = Base64.parse(data);

    const rawKey = process.env.REACT_APP_ENCRYPTION_KEY;
    let json;

    if (!rawKey) {
        throw new Error("REACT_APP_ENCRYPTION_KEY is not configured for this build");
    }
    const key = Utf8.parse(rawKey);

    if (key) {
        const decrypted = AES.decrypt({ ciphertext: base64Decoded }, key, {
            iv,
            padding: pad
        });

        const uint8Array = convertWordArrayToUint8Array(decrypted);
        const output = inflate(uint8Array, { to: "string" });

        json = JSON.parse(output);
        return json;
    }
    throw Error("Decryption Error");
}

export function encrypt(data) {
    if (typeof data !== "string") {
        return data;
    }
    const iv = Utf8.parse("RKz5xwoVgaXqfrh9");
    const state = store.getState();
    const rawKey = process.env.REACT_APP_ENCRYPTION_KEY;

    if (!rawKey) {
        throw new Error("REACT_APP_ENCRYPTION_KEY is not configured for this build");
    }
    const key = Utf8.parse(rawKey);

    if (key) {
        const encrypted = AES.encrypt(data, key, {
            iv
        }).toString();

        return encrypted;
    }
    throw Error("Encryption Error");
}
